import React from "react"
import Checkbox from "components/ReactHookForm/Checkbox"
import SwitchField from "components/ReactHookForm/SwitchField"
import { Box, Flex, Text } from "@chakra-ui/react"
import {
  Control, FieldValues, useWatch, UseFormSetValue,
} from "react-hook-form"
import applyPhoneWhatsappOptInSideEffects from "./phoneWhatsappOptInFieldSync"

type Props<T extends FieldValues> = {
  name: string
  control: Control<T, any>
  label: string
  disabled?: boolean
  requiredLocked?: boolean
  hideRequired?: boolean
  setValue?: UseFormSetValue<any>
  syncPhoneWithWhatsappOptIn?: boolean
}

const Field = <T extends FieldValues, >({
  name,
  control,
  label,
  disabled,
  requiredLocked,
  hideRequired,
  setValue,
  syncPhoneWithWhatsappOptIn = false,
}: Props<T>) => {
  const enabled = useWatch<any>({ control, name: `${name}Enabled` })

  return (
    <Flex
      align="center"
      justify="space-between"
      ml={6}
      py={3}
      borderBottomWidth={1}
      _last={{ borderBottomWidth: 0 }}
      color={!enabled ? "gray.400" : "auto"}
    >
      <Text as="span" fontSize="lg">{label}</Text>
      <Flex align="center">
        {!hideRequired && (
        <Checkbox
          name={`${name}Required`}
          control={control}
          label="Required"
          disabled={disabled || !enabled || requiredLocked}
          mb={-2}
        />
        )}
        <Box ml={hideRequired ? 0 : 4}><SwitchField
          name={`${name}Enabled`}
          control={control}
          mb={0}
          disabled={disabled}
          onChange={(event) => {
            const { checked } = event.target
            if (requiredLocked && checked && setValue) {
              setValue(`${name}Required`, true, { shouldDirty: true })
            }
            if (syncPhoneWithWhatsappOptIn && setValue) {
              applyPhoneWhatsappOptInSideEffects(
                name,
                checked,
                setValue,
              )
            }
          }}
        />
        </Box>
      </Flex>
    </Flex>
  )
}

export default Field
